const USER_NOMINATIONS = '/user/purple-ribbon/nominations'
const USER_NOMINATION_EDIT = id => `/user/purple-ribbon/nominations/${id}/edit`
const USER_NOMINATIONS_PAYMENT = '/user/purple-ribbon/nominations/payment'
const PRA_LOGIN = '/login'
const DS_ROUTES = window.DS.routes
const SENTRY_DSN_PUBLIC = window.DS.SENTRY_DSN_PUBLIC
const CAPTCHA_SITE_KEY = window.DS.CAPTCHA_SITE_KEY

export {
  USER_NOMINATIONS,
  USER_NOMINATION_EDIT,
  USER_NOMINATIONS_PAYMENT,
  PRA_LOGIN,
  DS_ROUTES,
  SENTRY_DSN_PUBLIC,
  CAPTCHA_SITE_KEY,
}
